import { normalizeCompanyTypes } from "./transportBidFlow";

export const MERCHANT_COMPANY_DOCUMENTS_PATH = "/my-warehouse-firm?tab=documents";

export function getNormalizedMerchantTypes(merchantCompanyTypes) {
  return normalizeCompanyTypes(merchantCompanyTypes)
    .map((item) => String(item || "").toLowerCase().trim())
    .filter(Boolean);
}

export function merchantHasDepoType(merchantCompanyTypes) {
  return getNormalizedMerchantTypes(merchantCompanyTypes).includes("depo");
}

export function merchantHasNakliyeType(merchantCompanyTypes) {
  return getNormalizedMerchantTypes(merchantCompanyTypes).includes("nakliye");
}

export function getMerchantDefaultPath({ merchantRole, merchantCompanyTypes } = {}) {
  if (merchantRole === null || merchantRole === undefined) return null;
  if (merchantRole === "admin") return MERCHANT_COMPANY_DOCUMENTS_PATH;
  if (merchantHasDepoType(merchantCompanyTypes)) return "/warehouse-list";
  if (merchantHasNakliyeType(merchantCompanyTypes)) return "/transport-requests";
  return "";
}
